import { render } from "./ConfigurationBusiness.vue?vue&type=template&id=71e38026&scoped=true"
import script from "./ConfigurationBusiness.vue?vue&type=script&lang=js"
export * from "./ConfigurationBusiness.vue?vue&type=script&lang=js"

import "./ConfigurationBusiness.vue?vue&type=style&index=0&id=71e38026&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e38026"]])

export default __exports__